<template>
    <div
        id="paikejl"
        v-loading="loadBool"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <div class="fflex fflexV fflexbet" style="margin-bottom: 10px;">
            <div>
                <el-button size="mini" class="ziBtn" @click="tiaoxj">
                    <img
                        src="/static/qmsj/img/newperson.png"
                        style="width:16px;vertical-align: middle"
                        alt
                    />
                    <span style="display: inline-block;vertical-align: middle">新建</span>
                </el-button>

                <span style="padding: 0 15px">排课记录</span>
                <el-button
                    size="mini"
                    round
                    class="boxshadow"
                    :class="{activex:(xuan==pki)}"
                    @click="zhouqs(pki,pk.start_time,pk.end_time)"
                    v-for="(pk,pki) in kjl.pk_records"
                    :key="pki"
                >
                    {{pk.start_time_status}}
                    <span v-if="pki == xuan">--{{pk.end_time}} ({{pk.diff_week}}周)</span>
                </el-button>
                <!--<el-button size="mini" round class="boxshadow">2018.03.19</el-button>-->
                <!--<el-button size="mini" round class="boxshadow">2018.03.19</el-button>-->
            </div>
            <div>
                <!--<el-button size="mini" round class="boxshadow"> 班级名称查询</el-button>-->
                <!--<select name="" class="xiala" >-->
                <!--<option value="">班级名称查询</option>-->
                <!--<option v-for="cla in kjl.classes" :value="cla.kc_id">{{cla.kc_name}}</option>-->
                <!--</select>-->
                <!-- <el-button size="mini" round class="boxshadow" @click="xiugaipaike">修改排课</el-button> -->
                <el-button
                    size="mini"
                    round
                    class="boxshadow"
                    @click="isPrint = true"
                    style="background-color: #8CBB77;padding: 7px 18px;color: white;"
                >打 印</el-button>
                <el-button size="mini" round class="boxshadow" @click="ylfbfn">课程分布</el-button>
                <el-button size="mini" round class="boxshadow" @click="yjpkt=true">一键排课</el-button>
                <el-button size="mini" round class="boxshadow" @click="tiaoxiugai">修改</el-button>
            </div>
        </div>

        <el-dialog title="提示" :visible.sync="isPrint" center width="23%">
            <div style="margin-left: 20px;">{{shaist}} - {{shaiet}} {{weeks}}</div>
            <div style="color: #7d72c1;margin-left: 20px;">您确认要打印这个时间段的课程表吗？</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isPrint = false" size="mini">取 消</el-button>
                <el-button type="success" @click="print" size="mini">确 定</el-button>
            </span>
        </el-dialog>

        <div style="width: 100%;overflow-x: scroll;" class="printBox">
            <div>
                <div
                    class="print_head"
                    style="width: 100%;margin-top: 70px;font-size: 40px;"
                >{{shaist}} — {{shaiet}}</div>
                <div class="print_head" style="width: 100%;">{{weeks}}</div>
                <table
                    class="table table-bordered"
                    style="box-shadow: none;margin-bottom: 10px;table-layout:fixed;width: auto!important;vertical-align: middle"
                >
                    <thead>
                        <tr>
                            <th
                                width="160"
                                style="width: 160px!important;background: #fff;padding:0  10px 0 0;vertical-align: middle"
                            >
                                <select
                                    name
                                    v-model="week"
                                    @change="shai()"
                                    class="xiala print_show"
                                    style="background:#8CBB77;color: #fff;width: 128px "
                                >
                                    <option v-for="w in week_list" :value="w.id">{{w.name}}</option>
                                </select>
                            </th>
                            <th
                                v-for="(k,index) in kjl.class_room_names"
                                style="width: 170px;page-break-after: always;"
                            >{{k.content}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(it,iidex) in kjl.infos">
                            <td
                                style="padding:5px  10px 5px 0;"
                                v-for="(kks,index) in it"
                                v-if="index==0"
                            >
                                <div
                                    class="fflex fflexC boxshadow"
                                    style="background:#8CBB77;flex-wrap: wrap;border-radius: 5px;padding: 5px;width: 160px "
                                >
                                    <div class="fflex fflexV" style="margin-bottom: 5px">
                                        <span>上课：</span>
                                        <div
                                            class="el-input--mini el-input__inner"
                                            style="width: 60px;padding-right: 0; padding-left: 5px;height: 28px;line-height: 28px;"
                                        >{{kks[0]}}</div>
                                    </div>
                                    <div class="fflex fflexV" style="margin-bottom: 5px">
                                        <span>下课：</span>
                                        <div
                                            class="el-input--mini el-input__inner"
                                            style="width: 60px;padding-right: 0; padding-left: 5px;height: 28px;line-height: 28px;"
                                        >{{kks[1]}}</div>
                                    </div>
                                </div>
                            </td>
                            <!-- :class="index == 6 ? 'print_page' : ''" -->
                            <td
                                v-for="(kk,index) in it"
                                v-if="index>0"
                                style="padding:5px  10px 5px 0;page-break-after: always;"
                            >
                                <div
                                    class="fflex fflexC"
                                    :class="{boxshadow:kk.kc_name,bgbai:kk.kc_name}"
                                    style="flex-wrap: wrap;border-radius: 5px;padding: 15px 5px;width: 160px "
                                >
                                    <div
                                        class="fflex fflexV"
                                        v-if="kk.kc_name"
                                        style="margin-bottom: 5px;min-width: 51%"
                                    >
                                        <span>课程/班级：</span>
                                        <span>{{kk.kc_name}}</span>
                                    </div>
                                    <div
                                        class="fflex fflexV"
                                        v-if="kk.kc_name"
                                        style="margin-bottom: 5px;min-width: 51%"
                                    >
                                        <span>{{kk.yueling}}~{{kk.yueling2}}月：</span>
                                        <span>{{kk.username}}</span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!--一键排课弹窗s-->
        <el-dialog class="tanchuang" title="一键排课" :visible.sync="yjpkt" width="500px">
            <div>
                <div style="margin-bottom: 15px">
                    <span>课程周期</span>
                    <select
                        name
                        class="xiala"
                        @change="zhoufn"
                        v-model="zhou"
                        style="margin-left: 15px;
                    width: 85px"
                    >
                        <option value="12">12周</option>
                        <option value="1">1周</option>
                        <option value="2">2周</option>
                        <option value="3">3周</option>
                        <option value="4">4周</option>
                        <option value="5">5周</option>
                        <option value="6">6周</option>
                        <option value="7">7周</option>
                        <option value="8">8周</option>
                        <option value="9">9周</option>
                        <option value="10">10周</option>
                        <option value="11">11周</option>
                    </select>
                    <span style="margin-left:75px;"></span>
                    <el-checkbox v-model="copygd">复制固定班学员</el-checkbox>
                </div>

                <div style="margin-bottom: 20px">
                    <span style="margin-right: 20px">开始时间</span>
                    <el-date-picker
                        @change="stfn"
                        v-model="stime"
                        size="mini"
                        value-format="yyyy-MM-dd"
                        style="width: 125px"
                        type="date"
                        placeholder="选择日期"
                        :picker-options="pickerOptions0"
                    ></el-date-picker>
                    <span style="margin-left:20px;margin-right: 20px">结束时间</span>

                    <el-date-picker
                        value-format="yyyy-MM-dd"
                        :disabled="true"
                        v-model="etime"
                        size="mini"
                        @change="stfn2"
                        style="width: 125px"
                        type="date"
                        placeholder="选择日期"
                    ></el-date-picker>
                </div>
                <p
                    style="font-size:12px ;line-height: 20px;color:#79c4c7;text-align: left"
                >注释：此次为一键排课，选择课程的周期及开始的时间（自动生成结束时间）自动复制现有的排课课程,但不包括上课老师。</p>
            </div>
            <div slot="footer" style="text-align: center">
                <el-button
                    size="mini"
                    round
                    style="background: #8CBB77;color: #fff"
                    @click="yijianp"
                >确定</el-button>
            </div>
        </el-dialog>
        <!--一键排课弹窗e-->

        <!--修改弹窗s-->
        <el-dialog class="tanchuang" title="修改排课" :visible.sync="xgt" width="430px">
            <div>
                <div style="margin-bottom: 20px">
                    <span>选择要修改的排课</span>
                    <el-button
                        size="mini"
                        round
                        class="boxshadow"
                        :class="{activex:xiuindex==kindex}"
                        v-for="(btn,kindex) in kebtn"
                        :key="kindex"
                        @click="xgpk(kindex,btn.start_time,btn.end_time)"
                    >{{btn.start_time}}</el-button>
                </div>
                <div style="margin-bottom: 20px">
                    <span>课程周期</span>
                    <select
                        name
                        class="xiala"
                        @change="zhoufnX"
                        v-model="zhouX"
                        style="margin-left: 20px;width: 250px"
                        id
                    >
                        <option value="12">12周</option>
                        <option value="1">1周</option>
                        <option value="2">2周</option>
                        <option value="3">3周</option>
                        <option value="4">4周</option>
                        <option value="5">5周</option>
                        <option value="6">6周</option>
                        <option value="7">7周</option>
                        <option value="8">8周</option>
                        <option value="9">9周</option>
                        <option value="10">10周</option>
                        <option value="11">11周</option>
                    </select>
                </div>
                <div style="margin-bottom: 20px">
                    <span style="margin-right: 20px;margin-bottom: 20px;">开始时间</span>
                    <el-date-picker
                        @change="stfnX"
                        v-model="stimeX"
                        size="mini"
                        value-format="yyyy-MM-dd"
                        style="width: 250px;margin-bottom: 20px;"
                        type="date"
                        placeholder="选择日期"
                    >
                        <!--:picker-options="pickerOptions0"-->
                    </el-date-picker>
                    <br />
                    <span style="margin-right: 20px">结束时间</span>

                    <el-date-picker
                        value-format="yyyy-MM-dd"
                        :disabled="true"
                        v-model="etimeX"
                        size="mini"
                        @change="stfn2X"
                        style="width: 250px"
                        type="date"
                        placeholder="选择日期"
                    ></el-date-picker>
                </div>
                <p
                    style="font-size:12px ;line-height: 20px;color:#79c4c7;text-align: left"
                >注释：此处为修改已有排课记录的排课时间，修改后不会生成新的排课记录。如需生成新的排课请点击一键排课。</p>
            </div>
            <div slot="footer" style="text-align: center">
                <el-button
                    size="mini"
                    round
                    style="background: #8CBB77;color: #fff"
                    @click="xiu_confirm"
                >确定</el-button>
            </div>
        </el-dialog>
        <!--修改弹窗e-->

        <!--月龄分布s-->
        <el-dialog class="tanchuang" title="一周课程统计" :visible.sync="ylfb" width="500px">
            <div>
                <div class="fflex fflexV" style="margin-bottom: 15px">
                    <span>选择周期 &nbsp;</span>
                    <!--kebtn kedata-->
                    <el-button
                        size="mini"
                        round
                        class="boxshadow"
                        :class="{activex:xuanzhong==kindex}"
                        @click="xuanzhong=kindex;shulength=kedata[xuanzhong].length"
                        v-for="(btn,kindex) in kebtn"
                        :key="kindex"
                    >{{btn.start_time}}</el-button>
                </div>

                <div :class="{tanbg:shulength>2}" style="text-align: center">
                    <el-row v-for="(da,kindex1) in kedata" v-if="xuanzhong==kindex1" :key="kindex1">
                        <el-col :span="8" v-for="(d,dindex) in da" :key="dindex">{{d.username}}：{{d.shu}}节</el-col>
                    </el-row>
                </div>
            </div>
        </el-dialog>
        <!--月龄分布e-->
    </div>
</template>

<script>
export default {
    data() {
        return {
            copygd: false,
            stime: "",
            etime: "",
            stimeX: "",
            etimeX: "",
            zhouX: "12",
            pickerOptions0: {
                disabledDate: ""
            },
            zhou: "12",
            startTime: new Date(1989, 1, 8, 0, 0),
            endTime: new Date(1989, 1, 8, 0, 0),
            sstartTime: "",
            yjpkt: false,
            xgt: false,
            ylfb: false,
            token: "",
            kjl: "",
            ylfbdata: "",
            xuan: "",
            shaist: "",
            shaiet: "",
            week: "3",
            weeks: "星期三", //星期几
            kebtn: "",
            kedata: "",
            xuanzhong: "0",
            shulength: "",
            xiuindex: "",
            xiu_start: "",
            xiu_end: "",
            print_lenth: 1,
            week_list: [
                {
                    name: "星期一",
                    id: "1"
                },
                {
                    name: "星期二",
                    id: "2"
                },
                {
                    name: "星期三",
                    id: "3"
                },
                {
                    name: "星期四",
                    id: "4"
                },
                {
                    name: "星期五",
                    id: "5"
                },
                {
                    name: "星期六",
                    id: "6"
                },
                {
                    name: "星期日",
                    id: "7"
                }
            ],
            need_classes: [],
            isPrint: false, //打印
            loadBool: false
        };
    },
    methods: {
        //打印
        print() {
            let self = this;
            this.$router.push({
                name: "paike_print",
                query: {
                    start_time: self.shaist,
                    end_time: self.shaiet,
                    week: self.week
                }
            });
        },
        yijianp: function() {
            this.loadBool = true;
            let self = this;

            $.ajax({
                url: process.env.apiUrl + "saas/paike/one_key_class",
                dataType: "json",
                type: "post",
                data: {
                    token: self.token,
                    t_start_time: self.stime,
                    t_end_time: self.etime,
                    copygd: self.copygd
                },
                success: function(data) {
                    if (data.status == 1) {
                        self.$message.success(`${data.msg}`);
                        self.yjpkt = false;
                        self.getData();
                    } else {
                        self.$message.error(`${data.msg}`);
                    }
                },
                complete: function() {
                    self.loadBool = false;
                }
            });
        },
        tiaoxj: function() {
            this.$router.push({
                name: "paike"
            });
        },
        tiaoxiugai: function() {
            this.$router.push({
                name: "paikexiu",
                query: {
                    week: this.week,
                    start: this.shaist,
                    end: this.shaiet
                }
            });
        },
        zhouqs: function(pk, stime, etime) {
            this.xuan = pk;
            this.shaist = stime;
            this.shaiet = etime;
            let self = this;
            self.shai();
        },
        shai: function() {
            this.loadBool = true;
            let self = this;
            $.ajax({
                url: process.env.apiUrl + "saas/paike/index",
                dataType: "json",
                type: "post",
                data: {
                    type: 1,
                    token: self.token,
                    start_time: self.shaist,
                    end_time: self.shaiet,
                    week: self.week
                },
                success: function(data) {
                    self.kjl = data.data;
                    for (var i = 0; i < data.data.pk_records.length; i++) {
                        if (data.data.pk_records[i].chose == 1) {
                            self.xuan = i;
                        }
                    }
                },
                complete: function() {
                    self.loadBool = false;
                }
            });
        },
        ylfbfn: function() {
            let self = this;
            $.ajax({
                url: process.env.apiUrl + "saas/paike/zhouke",
                dataType: "json",
                type: "post",
                data: {
                    token: this.token
                },
                success: function(data) {
                    if (data.status == 1) {
                        self.ylfb = true;
                        self.kebtn = data.data.cycles;
                        self.kedata = data.data.data;
                        self.shulength = self.kedata[self.xuanzhong].length;
                    } else {
                        self.$message.error("没有课程统计记录");
                    }
                }
            });
        },
        shuchuTime: function() {
            let time = new Date(this.startTime).getTime() + 60000 * 45;

            function timestampToTime(timestamp) {
                var date = new Date(timestamp);
                var h =
                    (date.getHours() < 10
                        ? "0" + date.getHours()
                        : date.getHours()) + ":";
                var m =
                    date.getMinutes() < 10
                        ? "0" + date.getMinutes()
                        : date.getMinutes() + ":";
                var s =
                    date.getSeconds() < 10
                        ? "0" + date.getSeconds()
                        : date.getSeconds();
                return h + m + s;
            }
            this.endTime = new Date(time);
            this.sstartTime = timestampToTime(time);
        },
        stfnX: function() {
            let self = this;
            let zhounum = Number(self.zhouX);
            let d =
                new Date(self.stimeX).getTime() +
                86400000 * 7 * zhounum -
                86400000;

            function timestampToTime(timestamp) {
                var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + "-";
                var M =
                    (date.getMonth() + 1 < 10
                        ? "0" + (date.getMonth() + 1)
                        : date.getMonth() + 1) + "-";
                //                var D = date.getDate() + ' ';
                var D =
                    date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
                var h = date.getHours() + ":";
                var m = date.getMinutes() + ":";
                var s = date.getSeconds();
                //                return Y+M+D+h+m+s;
                return Y + M + D;
            }
            this.etimeX = timestampToTime(d);
        },
        stfn2X: function() {
            let self = this;
            let zhounum = Number(self.zhouX);
            let d =
                new Date(self.stimeX).getTime() +
                86400000 * 7 * zhounum -
                86400000;

            function timestampToTime(timestamp) {
                var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + "-";
                var M =
                    (date.getMonth() + 1 < 10
                        ? "0" + (date.getMonth() + 1)
                        : date.getMonth() + 1) + "-";
                //                var D = date.getDate() + ' ';
                var D =
                    date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
                var h = date.getHours() + ":";
                var m = date.getMinutes() + ":";
                var s = date.getSeconds();
                return Y + M + D;
            }
            this.etimeX = timestampToTime(d);
        },
        stfn: function() {
            let self = this;
            let zhounum = Number(self.zhou);
            let d =
                new Date(self.stime).getTime() +
                86400000 * 7 * zhounum -
                86400000;

            function timestampToTime(timestamp) {
                var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + "-";
                var M =
                    (date.getMonth() + 1 < 10
                        ? "0" + (date.getMonth() + 1)
                        : date.getMonth() + 1) + "-";
                //                var D = date.getDate() + ' ';
                var D =
                    date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
                var h = date.getHours() + ":";
                var m = date.getMinutes() + ":";
                var s = date.getSeconds();
                //                return Y+M+D+h+m+s;
                return Y + M + D;
            }
            this.etime = timestampToTime(d);
        },
        stfn2: function() {
        },
        zhoufnX: function() {
            let self = this;
            let zhounum = Number(self.zhouX);
            let d =
                new Date(self.stimeX).getTime() +
                86400000 * 7 * zhounum -
                86400000;
            function timestampToTime(timestamp) {
                var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + "-";
                var M =
                    (date.getMonth() + 1 < 10
                        ? "0" + (date.getMonth() + 1)
                        : date.getMonth() + 1) + "-";
                var D =
                    date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
                var h = date.getHours() + ":";
                var m = date.getMinutes() + ":";
                var s = date.getSeconds();
                return Y + M + D;
            }
            this.etimeX = timestampToTime(d);
        },
        zhoufn: function() {
            let self = this;
            let zhounum = Number(self.zhou);
            let d =
                new Date(self.stime).getTime() +
                86400000 * 7 * zhounum -
                86400000;

            function timestampToTime(timestamp) {
                var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + "-";
                var M =
                    (date.getMonth() + 1 < 10
                        ? "0" + (date.getMonth() + 1)
                        : date.getMonth() + 1) + "-";
                //                var D = date.getDate() + ' ';
                var D =
                    date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
                var h = date.getHours() + ":";
                var m = date.getMinutes() + ":";
                var s = date.getSeconds();
                //                return Y+M+D+h+m+s;
                return Y + M + D;
            }
            this.etime = timestampToTime(d);
        },
        xiugaipaike: function() {
            this.xgt = true;
            let self = this;
            self.stimeX = "";
            self.etimeX = "";
            $.ajax({
                url: process.env.apiUrl + "saas/paike/zhouke",
                dataType: "json",
                type: "post",
                data: {
                    token: this.token
                },
                success: function(data) {
                    if (data.status == 1) {
                        self.kebtn = data.data.cycles;
                        self.xiuindex = 0;
                        self.xiu_start = data.data.cycles[0].start_time;
                        self.xiu_end = data.data.cycles[0].end_time;
                    } else {
                        self.$message.error("没有课程统计记录");
                    }
                }
            });
        },
        // 修改排课（弹窗）
        xgpk: function(i, s, e) {
            this.xiuindex = i;
            this.xiu_start = s;
            this.xiu_end = e;
        },
        // 修改排课确认（弹窗）
        xiu_confirm: function() {
            let self = this;
            $.ajax({
                url: process.env.apiUrl + "saas/paike/modify_pk_cycle",
                dataType: "json",
                type: "post",
                data: {
                    token: self.token,
                    x_start_time: self.stimeX,
                    x_end_time: self.etimeX,
                    y_start_time: self.xiu_start,
                    y_end_time: self.xiu_end,
                    type: 3
                },
                success: function(data) {
                    if (data.status == 1) {
                        self.$message.success(data.msg);
                        self.xgt = false;
                        self.shai();
                    } else {
                        self.$message.error(data.msg);
                    }
                }
            });
        },
        getData() {
            this.loadBool = true;
            let self = this;
            $.ajax({
                url: process.env.apiUrl + "saas/paike/index",
                dataType: "json",
                type: "post",
                data: {
                    token: this.token,
                    type: 1
                },
                success: function(data) {
                    self.need_classes = data.data.need_classes;
                    self.kjl = data.data;
                    for (var i = 0; i < data.data.pk_records.length; i++) {
                        if (data.data.pk_records[i].chose == 1) {
                            self.xuan = i;
                            self.shaist = data.data.pk_records[i].start_time;
                            self.shaiet = data.data.pk_records[i].end_time;
                        }
                    }
                },
                complete: function() {
                    self.loadBool = false;
                }
            });
        }
    },
    watch: {
        //星期格式化
        week() {
            if (this.week) {
                for (let i in this.week_list) {
                    if (this.week_list[i].id == this.week) {
                        this.weeks = this.week_list[i].name;
                    }
                }
            }
        }
    },
    created: function() {
        this.token = $.cookie("token");
        this.getData();

        let date = new Date();
        Date.prototype.Format = function(fmt) {
            var o = {
                "M+": this.getMonth() + 1, //月份
                "d+": this.getDate(), //日
                "h+": this.getHours(), //小时
                "m+": this.getMinutes(), //分
                "s+": this.getSeconds(), //秒
                "q+": Math.floor((this.getMonth() + 3) / 3), //季度
                S: this.getMilliseconds() //毫秒
            };
            if (/(y+)/.test(fmt))
                fmt = fmt.replace(
                    RegExp.$1,
                    (this.getFullYear() + "").substr(4 - RegExp.$1.length)
                );
            for (var k in o)
                if (new RegExp("(" + k + ")").test(fmt))
                    fmt = fmt.replace(
                        RegExp.$1,
                        RegExp.$1.length == 1
                            ? o[k]
                            : ("00" + o[k]).substr(("" + o[k]).length)
                    );
            return fmt;
        };
        let f = new Date().Format("yyyy-MM-dd");
        this.stime = f;

        //日期格式转换e
        let d = new Date(this.stime).getTime() + 86400000 * 7 * 12 - 86400000;

        function timestampToTime(timestamp) {
            var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + "-";
            var M =
                (date.getMonth() + 1 < 10
                    ? "0" + (date.getMonth() + 1)
                    : date.getMonth() + 1) + "-";
            //                var D = date.getDate() + ' ';
            var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            var h = date.getHours() + ":";
            var m = date.getMinutes() + ":";
            var s = date.getSeconds();
            //                return Y+M+D+h+m+s;
            return Y + M + D;
        }
        this.etime = timestampToTime(d);

        this.pickerOptions0.disabledDate = function disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
        };

        // this.shai()
    }
};
</script>

<style scoped>
#paikejl {
    min-height: 100%;
    background: #f8f8f8;
    margin: 0;
    padding: 15px;
    box-sizing: border-box;
    color: #666;
    font-size: 12px;
}

.activex {
    color: #8CBB77;
    border-color: #8CBB77;
}

.bgbai {
    background: #fff;
}

#paikejl * {
    box-sizing: border-box;
}

.xuanz.active {
    background: #79c4c7;
    color: #fff;
}

#paikejl ul,
p,
label {
    margin: 0;
    padding: 0;
}

.ziBtn {
    background: #8CBB77;
    color: #fff;
    padding-top: 5px;
    padding-bottom: 5px;
}

.tanbg {
    background-image: url(/static/qmsj/img/lanshux.png),
        url(/static/qmsj/img/lanshux.png);
    background-size: 2px 100%;
    background-position: 33% center, 66% center;
    background-repeat: no-repeat;
}

.xiala {
    width: 140px;
    height: 28px;
    line-height: 28px;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: 13px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.print_head {
    display: none;
}
</style>
<style lang="less">
#paikejl {
    .el-loading-mask {
        z-index: 9999;
    }
    .sjcj .el-input--suffix .el-input__inner {
        padding-right: 0;
        padding-left: 5px;
    }

    .sjcj .el-input__prefix {
        display: none;
    }

    .sjcj .el-input__icon .el-icon-time {
        display: none;
    }

    .sjcj .el-input__inner {
        padding-right: 0;
        padding-left: 5px;
    }

    .el-dialog__header {
        background-color:#8CBB77;
        padding: 10px 10px 10px 20px;
    }
    .el-dialog__headerbtn {
        top: 11px;
    }

    .print_page {
        page-break-after: always;
    }
}

@media print {
    .print_head {
        border: 1px solid #ddd;
        border-bottom: 0;
        display: block !important;
        text-align: center;
        font-size: 30px;
        margin: auto 60px;
        padding: 5px 0;
    }
    .print_show {
        visibility: hidden;
    }
    table {
        margin: auto 60px;
    }
    th,
    td {
        font-size: 16px;
    }
}
@page {
    size: auto;
    margin: 0mm;
}
</style>



// WEBPACK FOOTER //
// src/pages/paike/paikejl.vue